<header class="admin-header"
        [style.left]="(!state.isMobile() && state.sidebarOpen()) ? '256px' : '0px'">

  <!-- Hamburger toggle -->
  <button (click)="state.toggleSidebar()"
          class="p-2 rounded-lg transition-all duration-150 mr-4 flex-shrink-0"
          style="color: #2E3190; background: transparent;"
          onmouseenter="this.style.background='#f0f4ff'"
          onmouseleave="this.style.background='transparent'">
    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"/>
    </svg>
  </button>

  <!-- Brand (visible when sidebar is closed) -->
  @if (!state.sidebarOpen()) {
    <div class="flex items-center gap-2 mr-4">
      <img src="../../../../../../assets/template2/logo.png" alt="Afrilink" class="h-8 w-auto">
      <span class="font-bold text-base tracking-wide hidden sm:block" style="color: #2E3190;">
        AFRILINK
      </span>
    </div>
  }

  <div class="flex-1"></div>

  <!-- User dropdown -->
  <div class="relative">
    <button (click)="userMenuOpen = !userMenuOpen"
            class="flex items-center gap-2.5 px-3 py-2 rounded-xl transition-all duration-150"
            style="background: transparent;"
            onmouseenter="this.style.background='#f8fafc'"
            onmouseleave="this.style.background='transparent'">

      <!-- Avatar -->
      <div class="w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm flex-shrink-0"
           style="background: linear-gradient(135deg, #2E3190, #3a3eaa); color: white;">
        {{ (user?.officer?.lastname ?? user?.name ?? 'A').charAt(0).toUpperCase() }}
      </div>

      <!-- Name -->
      <div class="hidden md:flex flex-col text-left">
        <span class="text-sm font-semibold leading-tight" style="color: #1e293b;">
          {{ user?.officer?.lastname ?? user?.name ?? 'Admin' }}
          {{ user?.officer?.firstname ?? '' }}
        </span>
        <span class="text-xs leading-tight" style="color: #94a3b8;">{{ role }}</span>
      </div>

      <!-- Chevron -->
      <svg class="w-4 h-4 transition-transform duration-200 hidden md:block"
           [class.rotate-180]="userMenuOpen"
           style="color: #94a3b8;"
           fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
      </svg>
    </button>

    <!-- Dropdown -->
    @if (userMenuOpen) {
      <div class="absolute right-0 top-full mt-2 w-56 bg-white rounded-2xl overflow-hidden z-50"
           style="border: 1px solid #e8edf3; box-shadow: 0 8px 32px rgba(0,0,0,0.12); min-width: 220px;">

        <!-- User info -->
        <div class="px-4 py-3.5" style="background: linear-gradient(135deg, #f0f4ff, #e8edf8); border-bottom: 1px solid #e2e8f0;">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 rounded-full flex items-center justify-center font-bold"
                 style="background: linear-gradient(135deg, #2E3190, #3a3eaa); color: white; font-size: 1rem;">
              {{ (user?.officer?.lastname ?? user?.name ?? 'A').charAt(0).toUpperCase() }}
            </div>
            <div>
              <p class="text-sm font-semibold" style="color: #1e293b;">
                {{ user?.officer?.lastname ?? user?.name ?? 'Admin' }}
              </p>
              <p class="text-xs truncate" style="color: #64748b; max-width: 140px;">{{ user?.email }}</p>
            </div>
          </div>
        </div>

        <!-- Mon compte -->
        <a routerLink="/user-account"
           (click)="userMenuOpen = false"
           class="flex items-center gap-3 px-4 py-3 text-sm transition-colors no-underline"
           style="color: #374151;"
           onmouseenter="this.style.background='#f8fafc'"
           onmouseleave="this.style.background='transparent'">
          <div class="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
               style="background: #f0f4ff;">
            <svg class="w-4 h-4" style="color: #2E3190;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
            </svg>
          </div>
          Mon Compte
        </a>

        <div style="border-top: 1px solid #f1f5f9;"></div>

        <!-- Déconnexion -->
        <button (click)="logout()"
                class="w-full flex items-center gap-3 px-4 py-3 text-sm transition-colors border-0 bg-transparent cursor-pointer"
                style="color: #dc2626;"
                onmouseenter="this.style.background='#fff5f5'"
                onmouseleave="this.style.background='transparent'">
          <div class="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
               style="background: #fee2e2;">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
            </svg>
          </div>
          Déconnexion
        </button>
      </div>
    }
  </div>

</header>
